// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__H1Eg3","file":"styles_file__16roU"};